import React, { MouseEvent, useCallback, useState } from 'react'
import { Box, IconButton, Menu, MenuItem, ListItemIcon } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { MenuIconButtonProps, renderItemContentProps } from './type'

export const MenuIconButton: React.FC<MenuIconButtonProps> = ({
  menuItems = [],
  IconInButton = <MoreVertIcon />,
  IconButtonProps = {},
  MenuProps = {},
  ...props
}): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  const renderItemContent: renderItemContentProps = useCallback(
    ({ label, icon, onClick = (): void => undefined }, key): JSX.Element => {
      return (
        <MenuItem key={key} onClick={onClick}>
          {icon && <ListItemIcon>{icon}</ListItemIcon>}
          {label}
        </MenuItem>
      )
    },
    [],
  )

  const open = Boolean(anchorEl)

  return (
    <Box {...props}>
      <IconButton onClick={handleClick} {...IconButtonProps}>
        {IconInButton}
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        {...MenuProps}
      >
        {menuItems.map((item, index) => renderItemContent(item, index))}
      </Menu>
    </Box>
  )
}
